module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA20lEQVRYhe2UsQ0CMQxF/yEGYIITRQbiNoDySiahTMkIMFAKlAnYAHRSaGIptpNwAsmv9CXWy5d9MIxGBsn1MI8HABcAe/Ix4Xwc0tmr8/FEDgjZCGVuJZmM4yJFqr2EUjJaqqWKQmEed4pkcqqkikIdUEsVhZyPT1LUo5IqCnVELLWWEKRSW1Jp5PM/qmXNhESwrwnz+CLFBrgEfy4hE+JQb5l2i7Qz+P8J9d66HBtqDtsyDtsyDhtqDonQg1TqYXtJhM6kUg/bixVyPt4BTI1JLXen1MswvgeANxfaPCBatZ1HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_btn_confirmation_press@2x.png
// module id = 742
// module chunks = 0